import { FlexDate, FlexDateDto, FlexDateRangeDto, FlexWeekNDayDto, ICalendar } from "./types";

export function hasEntries(app: ICalendar) {
    return (app.dates && Object.keys(app.dates)?.length > 0) 
    || (app.dateRanges && Object.keys(app.dateRanges)?.length > 0) 
    || (app.weekNDays && Object.keys(app.weekNDays)?.length > 0);
}

export function date_intersects(entry: FlexDateDto, date: Date): boolean {
    const dayok = entry.day === 255 ? true : entry.day === date.getDate();
    const monok = monthOk(entry.month, date.getMonth() + 1);
    const yearok = entry.year === 255 ? true : entry.year + 1900 === date.getFullYear();
    const wdayok = entry.wday === 255 ? true : entry.wday === 7? entry.wday-7 === date.getDay(): entry.wday === date.getDay(); // toto recalc values
    return dayok && monok && yearok && wdayok;
}

function monthOk(setting: number, current: number): boolean {
    if (setting === 255) return true;
    if (setting === 13) return current % 2 !== 0; // odd months
    if (setting === 14) return current % 2 === 0; // even months
    return setting === current;
}

export function dateRange_intersects(entry: FlexDateRangeDto, date: Date): boolean {

    if (date_isFixDate(entry.start) && date_isFixDate(entry.end)) {
        const start = flexDate_asDate(entry.start);
        const end = flexDate_asDate(entry.end);
        return date.getTime() >= start.getTime() && date.getTime() <= end.getTime();
    }

    return false; // flex is not supported for now
}

export function weekNDay_intersects(entry: FlexWeekNDayDto, date: Date): boolean {

    const monok = monthOk(entry.month,date.getMonth());
    const dayOk = entry.weekDay === 255 ? true : entry.weekDay === date.getDay();
    const weekOk =  entry.week === 255 ? true : getWeekNumber(date) === entry.week;
    return monok && dayOk && weekOk;
}

 function getWeekNumber(date: Date): number {
     // January 4 is always in week 1.
     var week1 = new Date(date.getFullYear(), 0, 4);
     return  1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
                         - 3 + (week1.getDay() + 6) % 7) / 7);
}

export function date_isFixDate(entry: FlexDateDto): boolean {
    return entry.day !== 255 && entry.month <= 12 && entry.year !== 255; //&& entry.wday !== 255;
}

export function flexdate_isFixDate(entry: FlexDate): boolean {
    return !entry.flexDay && !entry.flexMonth && !entry.flexDay && !entry.evenMonths && !entry.oddMonths; //&& entry.wday !== 255;
}

export function flexDate_asDate(entry: FlexDateDto): Date {
    return new Date(entry.year + 1900, entry.month-1, entry.day);
}


export function toFlexDateDto(entry: FlexDate): FlexDateDto {
    const fDate: FlexDateDto = {
        day: entry.flexDay ? 255 : entry.date.getDate(),
        month: entry.flexMonth ? 255 : (entry.oddMonths ? 13 : entry.evenMonths ? 14 : entry.date.getMonth() + 1),
        year: entry.flexYear ? 255 : entry.date.getFullYear() - 1900,
        //wday: flexdate_isFixDate(entry) ? 255 : entry.date.getDay()
        wday: (entry.date.getDay() + 6) % 7 + 1,
        kind: 'FlexDateDto'
    };

    return fDate;
}

export function fromDateToFlexDateDto(entry: Date): FlexDateDto {
    const fDate: FlexDateDto = {
        day: entry.getDate(),
        month:  entry.getMonth() + 1,
        year: entry.getFullYear() - 1900,
        wday: (entry.getDay() + 6) % 7 + 1,
        kind: 'FlexDateDto'
    };

    return fDate;
}